import { QRCodeSVG } from 'qrcode.react';
import React from 'react';
import BannerPSC from '@/assets/smartcity/banner-psc.svg';
import Emergency from '@/assets/smartcity/emergency-intro.svg';
import IconPsc from '@/assets/smartcity/icon-psc.svg';
import Logo from '@/assets/smartcity/logo-light.svg';
import Phone from '@/assets/smartcity/phone.svg';
import PhoneBanner from '@/assets/smartcity/phone-banner.svg';
import StructureApp from '@/assets/smartcity/structure-app.webp';
import Why from '@/assets/smartcity/why-intr.svg';
import FaqDropdown from '@/domains/landing-page/component/FaqDropdown/FaqDropdown';
import FooterIntro from '@/domains/landing-page/component/FooterIntro/FooterIntro';
import HeaderIntro from '@/domains/landing-page/component/HeaderIntro/HeaderIntro';
import Wrapper from '@/domains/landing-page/component/Wrapper/Wrapper';
import { DATA_FEATURES } from '@/domains/landing-page/constants/features.constant';
import Button from '@/shared/components/ui/Button';
import { URLS } from '@/shared/config/urls';

// Newest APK published from Preference Management (Mobile App section). The
// route is public and answers with Content-Disposition: attachment, so the
// browser downloads in place instead of leaving the page.
const APK_DOWNLOAD_URL = `${URLS.BACK_DSH}/app-version/download/latest`;

const Introduction = () => {
  return (
    <main className="bg-[linear-gradient(180deg,_#017AFF_-119.35%,_#F3F6FE_22.65%)] w-full min-h-screen h-auto flex flex-col">
      <HeaderIntro />
      <Wrapper classStyle="section-hero" id="intro">
        <div className="lg:px-[50px] md:px-[50px] px-0 w-full  flex flex-col gap-6 justify-center items-center">
          <img src={IconPsc} alt="psc" loading="lazy" />
          <div className="w-full justify-center text-center flex items-center flex-col">
            <h1 className="text72 ">Use our new platform</h1>
            <h1 className="text72">for a better experience</h1>
          </div>
          <p className="h4 text-text-grey text-center">
            The PSC Mobile App helps ambulance teams receive emergency assignments, navigate to
            incident locations, update patient status in real time, and communicate seamlessly with
            the command center—all from a single application.
          </p>
          <Button
            label="Download App"
            variant="default"
            className="btn-fill-blue text-[20px] rounded-full hover:opacity-90 cursor-pointer"
            onClick={() => window.location.assign(APK_DOWNLOAD_URL)}
          />
          <div className="">
            <img src={Phone} alt="phone" className="max-w-full" loading="lazy" />
          </div>
        </div>
      </Wrapper>
      <Wrapper classStyle="section-emergency">
        <div className="grid grid-cols-1  items-center lg:grid-cols-2 md:grid-cols-2 lg:gap-[52px] md:gap-[52px] gap-6">
          <div className="md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48">Built for Faster Emergency Response</h3>
            <p className="h4 text-text-grey">
              Every second matters during an emergency. The PSC Mobile App is designed to support
              ambulance crews throughout the entire response process—from receiving dispatch
              requests to completing patient handovers.
            </p>
            <p className="h4 text-text-grey">
              With real-time updates, integrated navigation, assignment tracking, and instant
              communication, ambulance teams can focus on what matters most: saving lives.
            </p>
          </div>
          <div className="w-full">
            <img src={Emergency} alt="emergency" loading="lazy" className="max-w-full" />
          </div>
        </div>
      </Wrapper>
      <Wrapper classStyle="section-why">
        <div className="grid grid-cols-1  items-center lg:grid-cols-2 md:grid-cols-2 lg:gap-[52px] md:gap-[52px] gap-6">
          <div className="w-full order-2 md:order-1">
            <img src={Why} alt="emergency" loading="lazy" className="max-w-full" />
          </div>

          <div className="order-1 md:order-2  md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48">Why PSC?</h3>
            <p className="h4 text-text-grey">
              Instead of relying on multiple communication channels, PSC centralizes every
              operational activity into one secure mobile application.
            </p>
          </div>
        </div>
      </Wrapper>

      <Wrapper classStyle="section-feature" id="fitur">
        <div className="w-full flex flex-col gap-6 lg:gap-10 md:gap-10">
          <div className="md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48">Powerful Features for Every Emergency Mission</h3>
            <p className="h4 text-text-grey">
              Everything ambulance teams need to receive assignments, respond quickly, manage
              patient care, and complete operations efficiently.
            </p>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 gap-6">
            {DATA_FEATURES.map((item) => (
              <img
                key={item.id}
                src={item.img}
                alt={item.title}
                loading="lazy"
                className="w-full"
              />
            ))}
          </div>
        </div>
      </Wrapper>

      <Wrapper classStyle="section-how-it-works" id="howitworks">
        <div className="w-full flex flex-col gap-6 lg:gap-10 md:gap-10">
          <div className="md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48">How it Works?</h3>
            <p className="h4 text-text-grey">Simple Workflow for Every Emergency report Response</p>
          </div>
          <div className="md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48 text-text-blue-100">Home</h3>
            <p className="h4 text-text-grey">
              The Home screen in PSC serves as the main page for monitoring emergency incident
              reports. It provides an overview of the current report status, ongoing cases, and
              recent incident history, along with key details such as report ID, reporter, Number of
              Victim, locations, timestamps, and status.
            </p>
          </div>
          <div className="w-full h-full">
            <img src={StructureApp} alt="structure app" className="max-w-full" />
          </div>
        </div>
      </Wrapper>

      <Wrapper classStyle="section-faq" id="faq">
        <div className="w-full flex flex-col gap-6 lg:gap-10 md:gap-10">
          <div className="justify-center items-center text-center md:gap-6 lg:gap-6 gap-3 flex flex-col w-full">
            <h3 className="text48">Frequently Asked Question</h3>
            <p className="h4 text-text-grey">
              Find answers to the most frequently asked questions about the PSC Mobile App,
              including emergency operations, account management, and data security.
            </p>
          </div>
          <div className="w-full h-full">
            <FaqDropdown />
          </div>
        </div>
      </Wrapper>

      <Wrapper classStyle="section-banner ">
        <div className="w-full bg-[url('@/assets/smartcity/banner-sm.svg')] gap-6 overflow-hidden bg-cover bg-no-repeat p-6 md:p-10 lg:p-10 min-h-[500px] rounded-[24px] overflow-hidden p grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] md:grid-cols-[1.5fr_1fr] justify-between items-center">
          <div className=" w-full  flex flex-col gap-4 items-start ">
            <img src={Logo} alt="grobogan" />
            <span className="text36 text-white">
              Join the PSC Mobile App and empower your emergency response with faster dispatch,
              real-time coordination, and seamless mission management. Download the app today and
              help deliver faster, safer, and more efficient emergency medical services.
            </span>
            <div className="relative z-10 w-fit justify-center flex flex-col gap-2 items-center border p-3 rounded-[4px] bg-white/10 backdrop-blur-sm">
              <QRCodeSVG value={APK_DOWNLOAD_URL} size={100} className="rounded-[8px]" />
              <span className="title2 text-white">Scan QR to install</span>
            </div>
          </div>
          <div className=" relative z-10 w-fit justify-center m-auto lg:flex md:block hidden flex-col gap-2 items-center p-3 ">
            <img src={PhoneBanner} alt="phone-banner" className="max-w-full" />
          </div>
        </div>
      </Wrapper>

      <FooterIntro />
    </main>
  );
};

export default Introduction;
